import React from "react";
import { motion, useMotionValue, animate, useTransform } from "framer-motion";

// Number that counts up when it enters the viewport.
function Counter({ from = 0, to = 100, suffix = "", duration = 1.8 }) {
  const value = useMotionValue(from);
  const rounded = useTransform(value, (v) => `${Math.floor(v).toLocaleString("es-MX")}${suffix}`);
  const [ref, setRef] = React.useState(null);

  React.useEffect(() => {
    if (!ref) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          animate(value, to, { duration, ease: [0.25, 0.1, 0.25, 1] });
          io.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    io.observe(ref);
    return () => io.disconnect();
  }, [ref, to, duration, value]);

  return <motion.span ref={setRef}>{rounded}</motion.span>;
}

const STATS = [
  { to: 11, suffix: "", label: "Marcas aliadas", accent: "#3B82F6" },
  { to: 200, suffix: "+", label: "Vehículos entregados", accent: "#3B82F6" },
  { to: 90, suffix: "%", label: "Aprobación de crédito", accent: "#3B82F6" },
  { to: 24, suffix: " hrs", label: "Aprobación máxima", accent: "#3B82F6" },
];

export default function StatsSection() {
  return (
    <section
      className="relative py-20 md:py-28 border-t border-white/5"
      data-testid="stats-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="font-rajdhani font-medium text-[#3B82F6] text-xs md:text-sm tracking-[0.4em] uppercase">
            HEBEH en números
          </span>
          <h2 className="font-rajdhani font-semibold text-white text-4xl md:text-5xl leading-tight tracking-tight mt-4">
            Confianza que se demuestra
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="relative"
              data-testid={`stat-${i}`}
            >
              <p
                className="font-rajdhani font-medium leading-none text-4xl md:text-5xl lg:text-6xl tracking-tight"
                style={{ color: s.accent }}
              >
                <Counter to={s.to} suffix={s.suffix} />
              </p>
              <p className="font-manrope text-slate-300 mt-3 text-sm md:text-base">
                {s.label}
              </p>
              <div
                className="absolute -top-2 left-0 w-8 h-[2px]"
                style={{ backgroundColor: s.accent }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
